const en = {
  da_col_assignment_event_kind: 'Assignment event kind',
  da_source_assignment_event_kind:
    'Persisted ASSIGNED or REASSIGNED status event, linked only by explicit Offer ID.',
  da_null_assignment_event_kind: 'No explicitly linked confirmation event was recorded.',
  da_value_REASSIGNED: 'Reassigned',
  da_meaning_service_date:
    'Context only: scheduled start falls back to Trip creation. Audit filtering and ordering use offeredAt or standalone event time.',
  da_meaning_policy_version_id:
    'Only one non-null version across all supported snapshot leaves may populate the singular reference. Mixed or unsupported sources stay null; retained reference lists do not imply one policy.',
  da_meaning_candidate_score:
    'Recorded candidate score, not offer rank or a new evaluation. Linked-attempt retention markers override retained fragments and leave removed scores null.',
  da_meaning_confirmed_at:
    'Time of an explicitly linked assignment event or offer acceptance audit. An accepted offer without confirmation evidence stays null; respondedAt is not substituted.',
  da_meaning_confirmation_outcome:
    'Standalone confirmations do not increase Offer counts. They may overlap legacy offers, but no relationship is invented without an explicit Offer ID.',
  da_title: 'Driver assignment audit',
  da_description:
    'One row per persisted offer, plus legacy confirmations without an explicit canonical offer link. Reoffers remain separate. No rescoring, current-policy fallback, coordinates, addresses or finance. Standalone confirmations may be ambiguous; no Trip/Agent/time-based linking.',
  da_date_basis: 'Offer time or standalone confirmation time; not service date',
  da_summary_rowCount: 'Audit rows',
  da_summary_distinctTripCount: 'Distinct Trips',
  da_summary_offerCount: 'Offers',
  da_summary_acceptedOfferCount: 'Accepted offers',
  da_summary_rejectedOfferCount: 'Rejected offers',
  da_summary_expiredOfferCount: 'Expired offers',
  da_summary_supersededOfferCount: 'Superseded offers',
  da_summary_cancelledOfferCount: 'Cancelled offers',
  da_summary_pendingOfferCount: 'Pending offers',
  da_summary_confirmationOnlyCount: 'Standalone confirmations',
  da_summary_manualCount: 'Persisted manual assignments',
  da_summary_reassignmentCount: 'Persisted reassignments',
  da_summary_confirmedCount: 'Confirmation outcomes',
  da_summary_ambiguousConfirmationCount: 'Unlinked legacy confirmations (link ambiguity)',
  da_filter_rowKinds: 'Row kind',
  da_filter_offerKinds: 'Offer kind',
  da_filter_offerStatuses: 'Offer status',
  da_filter_dispatchModes: 'Historical dispatch mode',
  da_filter_strategies: 'Historical strategy',
  da_filter_searchPurposes: 'Search purpose',
  da_filter_evidenceStates: 'Evidence state',
  da_filter_agentIds: 'Agent IDs',
  da_filter_searchId: 'Search ID',
  da_filter_reasonCode: 'Exact persisted reason code',
  da_value_OFFER: 'Offer',
  da_value_ASSIGNMENT_EVENT: 'Legacy confirmation',
  da_value_LEGACY_HISTORY: 'Legacy history',
  da_value_AUTO_INITIAL: 'Automatic initial offer',
  da_value_MANUAL_INITIAL: 'Manual initial offer',
  da_value_MANUAL_REASSIGNMENT: 'Manual reassignment offer',
  da_value_PENDING: 'Pending',
  da_value_ACCEPTED: 'Accepted',
  da_value_REJECTED: 'Rejected',
  da_value_EXPIRED: 'Expired',
  da_value_SUPERSEDED: 'Superseded',
  da_value_CANCELLED: 'Cancelled',
  da_value_AUTO: 'Automatic',
  da_value_MANUAL: 'Manual',
  da_value_SEQUENTIAL: 'Sequential',
  da_value_BROADCAST: 'Broadcast',
  da_value_INITIAL: 'Initial assignment',
  da_value_REASSIGNMENT: 'Reassignment',
  da_value_AVAILABLE: 'Retained evidence',
  da_value_MISSING: 'Evidence unavailable',
  da_value_UNSUPPORTED: 'Unsupported snapshot schema',
  da_value_ASSIGNED: 'Assigned',
  da_value_ACTIVE: 'Active',
  da_value_EXHAUSTED: 'Exhausted',
  da_value_OFFERED_AT: 'Offer time',
  da_value_SCHEDULED_START: 'Scheduled start',
  da_value_CREATED_AT: 'Trip creation fallback',
  da_value_NOW: 'Immediate profile',
  da_value_SCHEDULED: 'Scheduled profile',
  da_value_RETRY: 'Retry',
  da_value_REFILL: 'Refill',
  da_value_MANUAL_REFRESH: 'Manual refresh',
  da_value_SYSTEM: 'System',
  da_value_PROVIDER: 'Provider',
  da_value_AREA: 'Service area',
  da_value_MIXED: 'Mixed persisted policy sources',
  da_value_AGENT: 'Agent',
  da_value_ORG_USER: 'Organisation staff',
  da_value_PASSENGER: 'Passenger',
  da_value_CURRENT_SERVICE_GROUP: 'Current service-group area mapping',
  da_value_STANDALONE_CONFIRMATION: 'Standalone confirmation; link unknown',
  da_value_LINKED_CONFIRMATION: 'Explicitly linked confirmation',
  da_value_ACCEPTED_WITHOUT_CONFIRMATION_EVENT: 'Accepted; confirmation event unavailable',
  da_value_NO_CONFIRMATION: 'No recorded confirmation',
  da_value_UNASSIGNED: 'Unassigned',
  da_value_AWAITING_PAYMENT: 'Awaiting payment',
  da_value_EN_ROUTE_PICKUP: 'En route to pickup',
  da_value_ARRIVED_PICKUP: 'Arrived at pickup',
  da_value_IN_PROGRESS: 'In progress',
  da_value_PICKED_UP: 'Picked up',
  da_value_ARRIVED_DROPOFF: 'Arrived at destination',
  da_value_COMPLETED: 'Completed',
  da_value_MISSED: 'Missed',
  da_value_AWAITING_OVERAGE: 'Awaiting extra payment',
  da_col_provider_id: 'Provider ID',
  da_source_provider_id: 'Current Provider master linked by Trip provider ID.',
  da_null_provider_id:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_provider_code: 'Provider code',
  da_source_provider_code: 'Current Provider master linked by Trip provider ID.',
  da_null_provider_code:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_provider_name: 'Provider name',
  da_source_provider_name: 'Current Provider master linked by Trip provider ID.',
  da_null_provider_name:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_row_key: 'Audit row key',
  da_source_row_key:
    'Persisted audit facts. Only explicit Offer IDs link confirmations; no time-based matching.',
  da_null_row_key:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_row_kind: 'Row kind',
  da_source_row_kind:
    'Persisted audit facts. Only explicit Offer IDs link confirmations; no time-based matching.',
  da_null_row_kind:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_trip_id: 'Trip ID',
  da_source_trip_id:
    'Persisted audit facts. Only explicit Offer IDs link confirmations; no time-based matching.',
  da_null_trip_id:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_trip_ref: 'Trip reference',
  da_source_trip_ref:
    'Current Trip context; service date is scheduled start or creation time. Area filters use current service-group mapping, never attempt area.',
  da_null_trip_ref:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_trip_status: 'Current Trip status',
  da_source_trip_status:
    'Current Trip context; service date is scheduled start or creation time. Area filters use current service-group mapping, never attempt area.',
  da_null_trip_status:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_service_date: 'Service date (context only)',
  da_source_service_date:
    'Current Trip context; service date is scheduled start or creation time. Area filters use current service-group mapping, never attempt area.',
  da_null_service_date:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_service_date_basis: 'Service date source',
  da_source_service_date_basis:
    'Current Trip context; service date is scheduled start or creation time. Area filters use current service-group mapping, never attempt area.',
  da_null_service_date_basis:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_event_at: 'Audit event time',
  da_source_event_at:
    'Persisted audit facts. Only explicit Offer IDs link confirmations; no time-based matching.',
  da_null_event_at:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_date_basis: 'Audit date basis',
  da_source_date_basis:
    'Persisted audit facts. Only explicit Offer IDs link confirmations; no time-based matching.',
  da_null_date_basis:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_offer_id: 'Offer ID',
  da_source_offer_id:
    'Persisted audit facts. Only explicit Offer IDs link confirmations; no time-based matching.',
  da_null_offer_id:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_assignment_event_id: 'Assignment event ID',
  da_source_assignment_event_id:
    'Persisted audit facts. Only explicit Offer IDs link confirmations; no time-based matching.',
  da_null_assignment_event_id:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_offer_kind: 'Offer kind',
  da_source_offer_kind:
    'Persisted audit facts. Only explicit Offer IDs link confirmations; no time-based matching.',
  da_null_offer_kind:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_offer_status: 'Offer status',
  da_source_offer_status:
    'Persisted audit facts. Only explicit Offer IDs link confirmations; no time-based matching.',
  da_null_offer_status:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_agent_id: 'Agent ID',
  da_source_agent_id:
    'Offer Agent or explicit legacy event recipient; contact/name/photo are current Agent master, not historical snapshots.',
  da_null_agent_id:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_agent_code: 'Agent code (not recorded)',
  da_source_agent_code:
    'Agent schema does not persist an Agent code; always unavailable, not inferred from another identity.',
  da_null_agent_code:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_agent_name: 'Current Agent name',
  da_source_agent_name:
    'Offer Agent or explicit legacy event recipient; contact/name/photo are current Agent master, not historical snapshots.',
  da_null_agent_name:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_agent_phone: 'Current Agent phone',
  da_source_agent_phone:
    'Offer Agent or explicit legacy event recipient; contact/name/photo are current Agent master, not historical snapshots.',
  da_null_agent_phone:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_dispatch_mode: 'Historical dispatch mode',
  da_source_dispatch_mode:
    'Persisted search snapshot and identity, never current Trip dispatch mode. Standalone mode only from an explicit event mode/via.',
  da_null_dispatch_mode:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_strategy: 'Historical search strategy',
  da_source_strategy:
    'Persisted search snapshot and identity, never current Trip dispatch mode. Standalone mode only from an explicit event mode/via.',
  da_null_strategy:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_search_id: 'Search ID',
  da_source_search_id:
    'Persisted search snapshot and identity, never current Trip dispatch mode. Standalone mode only from an explicit event mode/via.',
  da_null_search_id:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_search_number: 'Search number',
  da_source_search_number:
    'Persisted search snapshot and identity, never current Trip dispatch mode. Standalone mode only from an explicit event mode/via.',
  da_null_search_number:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_search_purpose: 'Search purpose',
  da_source_search_purpose:
    'Persisted search snapshot and identity, never current Trip dispatch mode. Standalone mode only from an explicit event mode/via.',
  da_null_search_purpose:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_search_state: 'Persisted search state',
  da_source_search_state:
    'Persisted search snapshot and identity, never current Trip dispatch mode. Standalone mode only from an explicit event mode/via.',
  da_null_search_state:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_attempt_id: 'Evaluation attempt ID',
  da_source_attempt_id:
    'Only the evaluation attempt explicitly referenced by this Offer; v2 and legacy attempts are unavailable. No latest-attempt fallback.',
  da_null_attempt_id:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_attempt_revision: 'Attempt revision',
  da_source_attempt_revision:
    'Only the evaluation attempt explicitly referenced by this Offer; v2 and legacy attempts are unavailable. No latest-attempt fallback.',
  da_null_attempt_revision:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_attempt_schema_version: 'Attempt schema version',
  da_source_attempt_schema_version:
    'Only the evaluation attempt explicitly referenced by this Offer; v2 and legacy attempts are unavailable. No latest-attempt fallback.',
  da_null_attempt_schema_version:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_attempt_profile: 'Attempt timing profile',
  da_source_attempt_profile:
    'Only the evaluation attempt explicitly referenced by this Offer; v2 and legacy attempts are unavailable. No latest-attempt fallback.',
  da_null_attempt_profile:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_attempt_trigger: 'Attempt trigger',
  da_source_attempt_trigger:
    'Only the evaluation attempt explicitly referenced by this Offer; v2 and legacy attempts are unavailable. No latest-attempt fallback.',
  da_null_attempt_trigger:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_attempt_computed_at: 'Attempt computed time',
  da_source_attempt_computed_at:
    'Only the evaluation attempt explicitly referenced by this Offer; v2 and legacy attempts are unavailable. No latest-attempt fallback.',
  da_null_attempt_computed_at:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_attempt_area_id: 'Attempt selected area ID',
  da_source_attempt_area_id:
    'Only the evaluation attempt explicitly referenced by this Offer; v2 and legacy attempts are unavailable. No latest-attempt fallback.',
  da_null_attempt_area_id:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_candidate_evaluation_id: 'Linked candidate evaluation ID',
  da_source_candidate_evaluation_id:
    'Persisted audit facts. Only explicit Offer IDs link confirmations; no time-based matching.',
  da_null_candidate_evaluation_id:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_policy_version_id: 'Unambiguous policy version ID',
  da_source_policy_version_id:
    'Supported v2 search or v3 linked-attempt per-leaf policy source snapshot. Singular version/scope requires one non-null unambiguous version. Mixed sources are disclosed; no current-policy fallback.',
  da_null_policy_version_id:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_policy_source: 'Policy source provenance',
  da_source_policy_source:
    'Supported v2 search or v3 linked-attempt per-leaf policy source snapshot. Singular version/scope requires one non-null unambiguous version. Mixed sources are disclosed; no current-policy fallback.',
  da_null_policy_source:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_policy_scope_id: 'Unambiguous policy scope ID',
  da_source_policy_scope_id:
    'Supported v2 search or v3 linked-attempt per-leaf policy source snapshot. Singular version/scope requires one non-null unambiguous version. Mixed sources are disclosed; no current-policy fallback.',
  da_null_policy_scope_id:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_policy_version_ids: 'Recorded policy version references',
  da_source_policy_version_ids:
    'Supported v2 search or v3 linked-attempt per-leaf policy source snapshot. Singular version/scope requires one non-null unambiguous version. Mixed sources are disclosed; no current-policy fallback.',
  da_null_policy_version_ids:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_policy_sources: 'Recorded policy scope sources',
  da_source_policy_sources:
    'Supported v2 search or v3 linked-attempt per-leaf policy source snapshot. Singular version/scope requires one non-null unambiguous version. Mixed sources are disclosed; no current-policy fallback.',
  da_null_policy_sources:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_offer_round: 'Offer round',
  da_source_offer_round:
    'Persisted audit facts. Only explicit Offer IDs link confirmations; no time-based matching.',
  da_null_offer_round:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_offer_sequence: 'Offer sequence',
  da_source_offer_sequence:
    'Persisted audit facts. Only explicit Offer IDs link confirmations; no time-based matching.',
  da_null_offer_sequence:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_offer_rank: 'Persisted offer rank',
  da_source_offer_rank:
    'Persisted Offer evidence only. Expired evidence remains unavailable even if another retained source exists.',
  da_null_offer_rank:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_candidate_score: 'Persisted candidate score',
  da_source_candidate_score:
    'Persisted score from the exact linked Candidate Evaluation in a supported schema. Never recalculated or defaulted to zero.',
  da_null_candidate_score:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_distance_to_pickup_km: 'Recorded distance to pickup (km)',
  da_source_distance_to_pickup_km:
    'Persisted Offer evidence only. Expired evidence remains unavailable even if another retained source exists.',
  da_null_distance_to_pickup_km:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_offered_at: 'Offered at',
  da_source_offered_at:
    'Persisted audit facts. Only explicit Offer IDs link confirmations; no time-based matching.',
  da_null_offered_at:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_expires_at: 'Offer deadline (not expiry event)',
  da_source_expires_at: 'Persisted response deadline, not a timestamp proving transition to EXPIRED.',
  da_null_expires_at:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_responded_at: 'Responded at',
  da_source_responded_at:
    'Persisted audit facts. Only explicit Offer IDs link confirmations; no time-based matching.',
  da_null_responded_at:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_confirmed_at: 'Confirmed at',
  da_source_confirmed_at:
    'Persisted audit facts. Only explicit Offer IDs link confirmations; no time-based matching.',
  da_null_confirmed_at:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_reason_id: 'Reason ID',
  da_source_reason_id:
    'Persisted audit facts. Only explicit Offer IDs link confirmations; no time-based matching.',
  da_null_reason_id:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_reason_code: 'Persisted reason code',
  da_source_reason_code:
    'Persisted audit facts. Only explicit Offer IDs link confirmations; no time-based matching.',
  da_null_reason_code:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_reason_label: 'Current reason label',
  da_source_reason_label: 'Current Provider-local reason master; not an immutable reason label snapshot.',
  da_null_reason_label:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_reason_note: 'Recorded reason note',
  da_source_reason_note:
    'Persisted Offer evidence only. Expired evidence remains unavailable even if another retained source exists.',
  da_null_reason_note:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_initiated_by_id: 'Initiating operator ID',
  da_source_initiated_by_id:
    'Persisted search snapshot and identity, never current Trip dispatch mode. Standalone mode only from an explicit event mode/via.',
  da_null_initiated_by_id:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_confirmation_actor_type: 'Confirmation actor type',
  da_source_confirmation_actor_type:
    'Immutable confirming actor name/ID/type from explicitly linked status event or offer acceptance audit; photo resolves current actor profile when supported.',
  da_null_confirmation_actor_type:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_confirmation_actor_id: 'Confirmation actor ID',
  da_source_confirmation_actor_id:
    'Immutable confirming actor name/ID/type from explicitly linked status event or offer acceptance audit; photo resolves current actor profile when supported.',
  da_null_confirmation_actor_id:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_confirmation_actor_name: 'Confirmation actor name snapshot',
  da_source_confirmation_actor_name:
    'Immutable confirming actor name/ID/type from explicitly linked status event or offer acceptance audit; photo resolves current actor profile when supported.',
  da_null_confirmation_actor_name:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_from_agent_id: 'Previous Agent ID',
  da_source_from_agent_id:
    'Persisted audit facts. Only explicit Offer IDs link confirmations; no time-based matching.',
  da_null_from_agent_id:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_to_agent_id: 'Assigned Agent ID',
  da_source_to_agent_id:
    'Persisted audit facts. Only explicit Offer IDs link confirmations; no time-based matching.',
  da_null_to_agent_id:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_confirmation_outcome: 'Confirmation outcome',
  da_source_confirmation_outcome:
    'Persisted audit facts. Only explicit Offer IDs link confirmations; no time-based matching.',
  da_null_confirmation_outcome:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_evidence_state: 'Evidence state',
  da_source_evidence_state:
    'Persisted offer/evaluation/attempt retention markers take precedence. Legacy, missing and unsupported evidence are explicit; no scores reconstructed.',
  da_null_evidence_state:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_evidence_expired_at: 'Evidence expired at',
  da_source_evidence_expired_at:
    'Persisted offer/evaluation/attempt retention markers take precedence. Legacy, missing and unsupported evidence are explicit; no scores reconstructed.',
  da_null_evidence_expired_at:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
  da_col_scope_provenance: 'Service area scope provenance',
  da_source_scope_provenance:
    'Current Trip context; service date is scheduled start or creation time. Area filters use current service-group mapping, never attempt area.',
  da_null_scope_provenance:
    'Not recorded, not applicable, unsupported, ambiguous or removed by retention; never an invented default.',
} as const;
const th: Record<keyof typeof en, string> = {
  da_col_assignment_event_kind: 'ชนิดเหตุการณ์ยืนยัน',
  da_source_assignment_event_kind: 'เหตุการณ์จัดงานหรือเปลี่ยนพนักงานที่บันทึก เชื่อมด้วยรหัสข้อเสนอโดยตรงเท่านั้น',
  da_null_assignment_event_kind: 'ไม่มีเหตุการณ์ยืนยันที่เชื่อมตรงซึ่งบันทึกไว้',
  da_value_REASSIGNED: 'เปลี่ยนพนักงานแล้ว',
  da_meaning_service_date:
    'ข้อมูลประกอบเท่านั้น ใช้เวลานัดหรือเวลาสร้างงาน ตัวกรองและลำดับประวัติใช้เวลาเสนอหรือเวลาเหตุการณ์แยกเดี่ยว',
  da_meaning_policy_version_id:
    'แสดงรหัสเดี่ยวเมื่อฟิลด์หลักฐานที่รองรับทั้งหมดอ้างหนึ่งรุ่นไม่ว่าง หลายแหล่งหรือไม่รองรับคงว่าง รายการรหัสที่เก็บไว้ไม่ได้หมายถึงนโยบายเดี่ยว',
  da_meaning_candidate_score:
    'คะแนนผู้สมัครที่บันทึก ไม่ใช่อันดับข้อเสนอหรือคะแนนประเมินใหม่ ตัวบ่งชี้ล้างหลักฐานในรอบที่เชื่อมมีลำดับก่อนเศษข้อมูลที่เก็บอยู่ คะแนนที่ล้างคงว่าง',
  da_meaning_confirmed_at:
    'เวลาเหตุการณ์จัดงานที่เชื่อมตรงหรือประวัติตอบรับ ข้อเสนอที่ตอบรับแต่ไม่มีหลักฐานยืนยันคงว่าง ไม่ใช้เวลาตอบแทน',
  da_meaning_confirmation_outcome:
    'การยืนยันแยกเดี่ยวไม่เพิ่มจำนวนข้อเสนอ อาจทับซ้อนข้อเสนอระบบเดิม แต่ไม่สร้างความสัมพันธ์หากไม่มีรหัสข้อเสนอโดยตรง',
  da_title: 'ประวัติการเสนอและจัดงานพนักงาน',
  da_description:
    'หนึ่งแถวต่อข้อเสนอที่บันทึก และการยืนยันแบบเดิมที่ไม่มีรหัสเชื่อมข้อเสนอหลัก การเสนอซ้ำเป็นคนละแถว ไม่คำนวณคะแนนใหม่ ไม่ใช้นโยบายปัจจุบันแทน ไม่มีพิกัด ที่อยู่ หรือการเงิน การยืนยันแยกอาจมีความคลุมเครือ ไม่เชื่อมด้วยงาน พนักงาน หรือเวลา',
  da_date_basis: 'เวลาเสนอหรือเวลายืนยันแยกเดี่ยว ไม่ใช่วันบริการ',
  da_summary_rowCount: 'แถวประวัติ',
  da_summary_distinctTripCount: 'งานไม่ซ้ำ',
  da_summary_offerCount: 'ข้อเสนอ',
  da_summary_acceptedOfferCount: 'ข้อเสนอที่ตอบรับ',
  da_summary_rejectedOfferCount: 'ข้อเสนอที่ปฏิเสธ',
  da_summary_expiredOfferCount: 'ข้อเสนอหมดอายุ',
  da_summary_supersededOfferCount: 'ข้อเสนอถูกแทนที่',
  da_summary_cancelledOfferCount: 'ข้อเสนอยกเลิก',
  da_summary_pendingOfferCount: 'ข้อเสนอรอตอบ',
  da_summary_confirmationOnlyCount: 'การยืนยันแยกเดี่ยว',
  da_summary_manualCount: 'การจัดงานด้วยตนเองที่มีหลักฐาน',
  da_summary_reassignmentCount: 'การเปลี่ยนพนักงานที่มีหลักฐาน',
  da_summary_confirmedCount: 'รายการที่ยืนยันแล้ว',
  da_summary_ambiguousConfirmationCount: 'การยืนยันแบบเดิมไม่ทราบการเชื่อม (คลุมเครือ)',
  da_filter_rowKinds: 'ชนิดแถว',
  da_filter_offerKinds: 'ชนิดข้อเสนอ',
  da_filter_offerStatuses: 'สถานะข้อเสนอ',
  da_filter_dispatchModes: 'รูปแบบจัดงานในประวัติ',
  da_filter_strategies: 'กลยุทธ์ในประวัติ',
  da_filter_searchPurposes: 'วัตถุประสงค์ค้นหา',
  da_filter_evidenceStates: 'สถานะหลักฐาน',
  da_filter_agentIds: 'รหัสพนักงาน',
  da_filter_searchId: 'รหัสการค้นหา',
  da_filter_reasonCode: 'รหัสเหตุผลที่บันทึก (ตรงตัว)',
  da_value_OFFER: 'ข้อเสนอ',
  da_value_ASSIGNMENT_EVENT: 'ยืนยันงานแบบเดิม',
  da_value_LEGACY_HISTORY: 'ประวัติระบบเดิม',
  da_value_AUTO_INITIAL: 'ข้อเสนอเริ่มต้นอัตโนมัติ',
  da_value_MANUAL_INITIAL: 'ข้อเสนอเริ่มต้นด้วยตนเอง',
  da_value_MANUAL_REASSIGNMENT: 'ข้อเสนอเปลี่ยนพนักงาน',
  da_value_PENDING: 'รอตอบ',
  da_value_ACCEPTED: 'ตอบรับ',
  da_value_REJECTED: 'ปฏิเสธ',
  da_value_EXPIRED: 'หมดอายุ',
  da_value_SUPERSEDED: 'ถูกแทนที่',
  da_value_CANCELLED: 'ยกเลิก',
  da_value_AUTO: 'อัตโนมัติ',
  da_value_MANUAL: 'ด้วยตนเอง',
  da_value_SEQUENTIAL: 'ทีละคน',
  da_value_BROADCAST: 'พร้อมกัน',
  da_value_INITIAL: 'จัดงานครั้งแรก',
  da_value_REASSIGNMENT: 'เปลี่ยนพนักงาน',
  da_value_AVAILABLE: 'มีหลักฐานที่เก็บไว้',
  da_value_MISSING: 'ไม่มีหลักฐาน',
  da_value_UNSUPPORTED: 'โครงสร้างหลักฐานที่ไม่รองรับ',
  da_value_ASSIGNED: 'มอบหมายแล้ว',
  da_value_ACTIVE: 'ดำเนินการ',
  da_value_EXHAUSTED: 'สิ้นสุดการค้นหา',
  da_value_OFFERED_AT: 'เวลาเสนอ',
  da_value_SCHEDULED_START: 'เวลาเริ่มตามนัด',
  da_value_CREATED_AT: 'ใช้เวลาสร้างงาน',
  da_value_NOW: 'โปรไฟล์งานทันที',
  da_value_SCHEDULED: 'โปรไฟล์งานนัดหมาย',
  da_value_RETRY: 'ลองใหม่',
  da_value_REFILL: 'เติมข้อเสนอ',
  da_value_MANUAL_REFRESH: 'รีเฟรชด้วยตนเอง',
  da_value_SYSTEM: 'ระบบ',
  da_value_PROVIDER: 'หน่วยงาน',
  da_value_AREA: 'พื้นที่บริการ',
  da_value_MIXED: 'หลายแหล่งนโยบายที่บันทึก',
  da_value_AGENT: 'พนักงาน',
  da_value_ORG_USER: 'เจ้าหน้าที่หน่วยงาน',
  da_value_PASSENGER: 'ผู้ใช้บริการ',
  da_value_CURRENT_SERVICE_GROUP: 'ผังพื้นที่ของกลุ่มบริการปัจจุบัน',
  da_value_STANDALONE_CONFIRMATION: 'ยืนยันแยกเดี่ยว ไม่ทราบการเชื่อม',
  da_value_LINKED_CONFIRMATION: 'ยืนยันที่เชื่อมรหัสข้อเสนอ',
  da_value_ACCEPTED_WITHOUT_CONFIRMATION_EVENT: 'ตอบรับแล้ว ไม่มีเหตุการณ์ยืนยัน',
  da_value_NO_CONFIRMATION: 'ไม่มีการยืนยันที่บันทึก',
  da_value_UNASSIGNED: 'ยังไม่จัดงาน',
  da_value_AWAITING_PAYMENT: 'รอชำระเงิน',
  da_value_EN_ROUTE_PICKUP: 'กำลังไปรับ',
  da_value_ARRIVED_PICKUP: 'ถึงจุดรับ',
  da_value_IN_PROGRESS: 'กำลังให้บริการ',
  da_value_PICKED_UP: 'รับแล้ว',
  da_value_ARRIVED_DROPOFF: 'ถึงปลายทาง',
  da_value_COMPLETED: 'เสร็จสิ้น',
  da_value_MISSED: 'ไม่ได้ให้บริการ',
  da_value_AWAITING_OVERAGE: 'รอชำระส่วนเกิน',
  da_col_provider_id: 'รหัสหน่วยงาน',
  da_source_provider_id: 'ข้อมูลหน่วยงานปัจจุบันที่เชื่อมด้วยรหัสหน่วยงานของงาน',
  da_null_provider_id: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_provider_code: 'รหัสอ้างอิงหน่วยงาน',
  da_source_provider_code: 'ข้อมูลหน่วยงานปัจจุบันที่เชื่อมด้วยรหัสหน่วยงานของงาน',
  da_null_provider_code: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_provider_name: 'ชื่อหน่วยงาน',
  da_source_provider_name: 'ข้อมูลหน่วยงานปัจจุบันที่เชื่อมด้วยรหัสหน่วยงานของงาน',
  da_null_provider_name: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_row_key: 'คีย์แถวประวัติ',
  da_source_row_key: 'ข้อมูลประวัติที่บันทึก เชื่อมการยืนยันด้วยรหัสข้อเสนอเท่านั้น ไม่จับคู่ด้วยเวลา',
  da_null_row_key: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_row_kind: 'ชนิดแถว',
  da_source_row_kind: 'ข้อมูลประวัติที่บันทึก เชื่อมการยืนยันด้วยรหัสข้อเสนอเท่านั้น ไม่จับคู่ด้วยเวลา',
  da_null_row_kind: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_trip_id: 'รหัสงาน',
  da_source_trip_id: 'ข้อมูลประวัติที่บันทึก เชื่อมการยืนยันด้วยรหัสข้อเสนอเท่านั้น ไม่จับคู่ด้วยเวลา',
  da_null_trip_id: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_trip_ref: 'เลขอ้างอิงงาน',
  da_source_trip_ref:
    'ข้อมูลประกอบงานปัจจุบัน วันบริการใช้เวลานัดหรือเวลาสร้าง ตัวกรองพื้นที่ใช้ผังกลุ่มบริการปัจจุบัน ไม่ใช้พื้นที่รอบประเมิน',
  da_null_trip_ref: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_trip_status: 'สถานะงานปัจจุบัน',
  da_source_trip_status:
    'ข้อมูลประกอบงานปัจจุบัน วันบริการใช้เวลานัดหรือเวลาสร้าง ตัวกรองพื้นที่ใช้ผังกลุ่มบริการปัจจุบัน ไม่ใช้พื้นที่รอบประเมิน',
  da_null_trip_status: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_service_date: 'วันบริการ (ข้อมูลประกอบ)',
  da_source_service_date:
    'ข้อมูลประกอบงานปัจจุบัน วันบริการใช้เวลานัดหรือเวลาสร้าง ตัวกรองพื้นที่ใช้ผังกลุ่มบริการปัจจุบัน ไม่ใช้พื้นที่รอบประเมิน',
  da_null_service_date: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_service_date_basis: 'แหล่งวันบริการ',
  da_source_service_date_basis:
    'ข้อมูลประกอบงานปัจจุบัน วันบริการใช้เวลานัดหรือเวลาสร้าง ตัวกรองพื้นที่ใช้ผังกลุ่มบริการปัจจุบัน ไม่ใช้พื้นที่รอบประเมิน',
  da_null_service_date_basis: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_event_at: 'เวลาประวัติ',
  da_source_event_at: 'ข้อมูลประวัติที่บันทึก เชื่อมการยืนยันด้วยรหัสข้อเสนอเท่านั้น ไม่จับคู่ด้วยเวลา',
  da_null_event_at: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_date_basis: 'เกณฑ์วันที่ประวัติ',
  da_source_date_basis: 'ข้อมูลประวัติที่บันทึก เชื่อมการยืนยันด้วยรหัสข้อเสนอเท่านั้น ไม่จับคู่ด้วยเวลา',
  da_null_date_basis: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_offer_id: 'รหัสข้อเสนอ',
  da_source_offer_id: 'ข้อมูลประวัติที่บันทึก เชื่อมการยืนยันด้วยรหัสข้อเสนอเท่านั้น ไม่จับคู่ด้วยเวลา',
  da_null_offer_id: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_assignment_event_id: 'รหัสเหตุการณ์ยืนยัน',
  da_source_assignment_event_id: 'ข้อมูลประวัติที่บันทึก เชื่อมการยืนยันด้วยรหัสข้อเสนอเท่านั้น ไม่จับคู่ด้วยเวลา',
  da_null_assignment_event_id: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_offer_kind: 'ชนิดข้อเสนอ',
  da_source_offer_kind: 'ข้อมูลประวัติที่บันทึก เชื่อมการยืนยันด้วยรหัสข้อเสนอเท่านั้น ไม่จับคู่ด้วยเวลา',
  da_null_offer_kind: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_offer_status: 'สถานะข้อเสนอ',
  da_source_offer_status: 'ข้อมูลประวัติที่บันทึก เชื่อมการยืนยันด้วยรหัสข้อเสนอเท่านั้น ไม่จับคู่ด้วยเวลา',
  da_null_offer_status: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_agent_id: 'รหัสพนักงาน',
  da_source_agent_id: 'พนักงานในข้อเสนอหรือผู้รับงานที่ระบุในเหตุการณ์เดิม ชื่อ เบอร์ และรูปเป็นข้อมูลปัจจุบัน ไม่ใช่ภาพประวัติ',
  da_null_agent_id: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_agent_code: 'รหัสอ้างอิงพนักงาน (ไม่มีการบันทึก)',
  da_source_agent_code: 'โครงสร้างพนักงานไม่มีรหัสอ้างอิง จึงไม่มีข้อมูล ไม่สร้างจากตัวตนอื่น',
  da_null_agent_code: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_agent_name: 'ชื่อพนักงานปัจจุบัน',
  da_source_agent_name: 'พนักงานในข้อเสนอหรือผู้รับงานที่ระบุในเหตุการณ์เดิม ชื่อ เบอร์ และรูปเป็นข้อมูลปัจจุบัน ไม่ใช่ภาพประวัติ',
  da_null_agent_name: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_agent_phone: 'เบอร์พนักงานปัจจุบัน',
  da_source_agent_phone: 'พนักงานในข้อเสนอหรือผู้รับงานที่ระบุในเหตุการณ์เดิม ชื่อ เบอร์ และรูปเป็นข้อมูลปัจจุบัน ไม่ใช่ภาพประวัติ',
  da_null_agent_phone: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_dispatch_mode: 'รูปแบบจัดงานในประวัติ',
  da_source_dispatch_mode:
    'ภาพประวัติและรหัสการค้นหาที่บันทึก ไม่ใช้รูปแบบจัดงานปัจจุบัน รูปแบบแถวแยกเดี่ยวใช้เฉพาะ mode/via ที่ระบุในเหตุการณ์',
  da_null_dispatch_mode: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_strategy: 'กลยุทธ์ค้นหาในประวัติ',
  da_source_strategy:
    'ภาพประวัติและรหัสการค้นหาที่บันทึก ไม่ใช้รูปแบบจัดงานปัจจุบัน รูปแบบแถวแยกเดี่ยวใช้เฉพาะ mode/via ที่ระบุในเหตุการณ์',
  da_null_strategy: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_search_id: 'รหัสการค้นหา',
  da_source_search_id:
    'ภาพประวัติและรหัสการค้นหาที่บันทึก ไม่ใช้รูปแบบจัดงานปัจจุบัน รูปแบบแถวแยกเดี่ยวใช้เฉพาะ mode/via ที่ระบุในเหตุการณ์',
  da_null_search_id: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_search_number: 'ลำดับการค้นหา',
  da_source_search_number:
    'ภาพประวัติและรหัสการค้นหาที่บันทึก ไม่ใช้รูปแบบจัดงานปัจจุบัน รูปแบบแถวแยกเดี่ยวใช้เฉพาะ mode/via ที่ระบุในเหตุการณ์',
  da_null_search_number: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_search_purpose: 'วัตถุประสงค์การค้นหา',
  da_source_search_purpose:
    'ภาพประวัติและรหัสการค้นหาที่บันทึก ไม่ใช้รูปแบบจัดงานปัจจุบัน รูปแบบแถวแยกเดี่ยวใช้เฉพาะ mode/via ที่ระบุในเหตุการณ์',
  da_null_search_purpose: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_search_state: 'สถานะการค้นหาที่บันทึก',
  da_source_search_state:
    'ภาพประวัติและรหัสการค้นหาที่บันทึก ไม่ใช้รูปแบบจัดงานปัจจุบัน รูปแบบแถวแยกเดี่ยวใช้เฉพาะ mode/via ที่ระบุในเหตุการณ์',
  da_null_search_state: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_attempt_id: 'รหัสรอบประเมิน',
  da_source_attempt_id: 'ใช้เฉพาะรอบประเมินที่ข้อเสนอนี้อ้างอิง v2 และระบบเดิมไม่มีรอบประเมิน ไม่ใช้รอบล่าสุดแทน',
  da_null_attempt_id: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_attempt_revision: 'รุ่นรอบประเมิน',
  da_source_attempt_revision: 'ใช้เฉพาะรอบประเมินที่ข้อเสนอนี้อ้างอิง v2 และระบบเดิมไม่มีรอบประเมิน ไม่ใช้รอบล่าสุดแทน',
  da_null_attempt_revision: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_attempt_schema_version: 'รุ่นโครงสร้างรอบประเมิน',
  da_source_attempt_schema_version: 'ใช้เฉพาะรอบประเมินที่ข้อเสนอนี้อ้างอิง v2 และระบบเดิมไม่มีรอบประเมิน ไม่ใช้รอบล่าสุดแทน',
  da_null_attempt_schema_version: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_attempt_profile: 'โปรไฟล์เวลารอบประเมิน',
  da_source_attempt_profile: 'ใช้เฉพาะรอบประเมินที่ข้อเสนอนี้อ้างอิง v2 และระบบเดิมไม่มีรอบประเมิน ไม่ใช้รอบล่าสุดแทน',
  da_null_attempt_profile: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_attempt_trigger: 'สาเหตุเริ่มรอบประเมิน',
  da_source_attempt_trigger: 'ใช้เฉพาะรอบประเมินที่ข้อเสนอนี้อ้างอิง v2 และระบบเดิมไม่มีรอบประเมิน ไม่ใช้รอบล่าสุดแทน',
  da_null_attempt_trigger: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_attempt_computed_at: 'เวลาประเมินรอบ',
  da_source_attempt_computed_at: 'ใช้เฉพาะรอบประเมินที่ข้อเสนอนี้อ้างอิง v2 และระบบเดิมไม่มีรอบประเมิน ไม่ใช้รอบล่าสุดแทน',
  da_null_attempt_computed_at: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_attempt_area_id: 'รหัสพื้นที่ที่ใช้ประเมิน',
  da_source_attempt_area_id: 'ใช้เฉพาะรอบประเมินที่ข้อเสนอนี้อ้างอิง v2 และระบบเดิมไม่มีรอบประเมิน ไม่ใช้รอบล่าสุดแทน',
  da_null_attempt_area_id: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_candidate_evaluation_id: 'รหัสผลประเมินที่เชื่อม',
  da_source_candidate_evaluation_id: 'ข้อมูลประวัติที่บันทึก เชื่อมการยืนยันด้วยรหัสข้อเสนอเท่านั้น ไม่จับคู่ด้วยเวลา',
  da_null_candidate_evaluation_id:
    'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_policy_version_id: 'รหัสรุ่นนโยบายที่ระบุได้แน่ชัด',
  da_source_policy_version_id:
    'หลักฐานแหล่งนโยบายรายฟิลด์ในภาพค้นหา v2 หรือรอบที่เชื่อมของ v3 รหัสรุ่นหรือขอบเขตเดี่ยวแสดงเฉพาะเมื่อชัดเจนหนึ่งรุ่นไม่ว่าง เปิดเผยหลายแหล่ง ไม่ใช้นโยบายปัจจุบันแทน',
  da_null_policy_version_id: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_policy_source: 'ที่มานโยบาย',
  da_source_policy_source:
    'หลักฐานแหล่งนโยบายรายฟิลด์ในภาพค้นหา v2 หรือรอบที่เชื่อมของ v3 รหัสรุ่นหรือขอบเขตเดี่ยวแสดงเฉพาะเมื่อชัดเจนหนึ่งรุ่นไม่ว่าง เปิดเผยหลายแหล่ง ไม่ใช้นโยบายปัจจุบันแทน',
  da_null_policy_source: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_policy_scope_id: 'รหัสขอบเขตนโยบายที่ระบุได้แน่ชัด',
  da_source_policy_scope_id:
    'หลักฐานแหล่งนโยบายรายฟิลด์ในภาพค้นหา v2 หรือรอบที่เชื่อมของ v3 รหัสรุ่นหรือขอบเขตเดี่ยวแสดงเฉพาะเมื่อชัดเจนหนึ่งรุ่นไม่ว่าง เปิดเผยหลายแหล่ง ไม่ใช้นโยบายปัจจุบันแทน',
  da_null_policy_scope_id: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_policy_version_ids: 'รายการรหัสรุ่นนโยบายที่บันทึก',
  da_source_policy_version_ids:
    'หลักฐานแหล่งนโยบายรายฟิลด์ในภาพค้นหา v2 หรือรอบที่เชื่อมของ v3 รหัสรุ่นหรือขอบเขตเดี่ยวแสดงเฉพาะเมื่อชัดเจนหนึ่งรุ่นไม่ว่าง เปิดเผยหลายแหล่ง ไม่ใช้นโยบายปัจจุบันแทน',
  da_null_policy_version_ids: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_policy_sources: 'รายการแหล่งขอบเขตนโยบายที่บันทึก',
  da_source_policy_sources:
    'หลักฐานแหล่งนโยบายรายฟิลด์ในภาพค้นหา v2 หรือรอบที่เชื่อมของ v3 รหัสรุ่นหรือขอบเขตเดี่ยวแสดงเฉพาะเมื่อชัดเจนหนึ่งรุ่นไม่ว่าง เปิดเผยหลายแหล่ง ไม่ใช้นโยบายปัจจุบันแทน',
  da_null_policy_sources: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_offer_round: 'รอบข้อเสนอ',
  da_source_offer_round: 'ข้อมูลประวัติที่บันทึก เชื่อมการยืนยันด้วยรหัสข้อเสนอเท่านั้น ไม่จับคู่ด้วยเวลา',
  da_null_offer_round: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_offer_sequence: 'ลำดับข้อเสนอ',
  da_source_offer_sequence: 'ข้อมูลประวัติที่บันทึก เชื่อมการยืนยันด้วยรหัสข้อเสนอเท่านั้น ไม่จับคู่ด้วยเวลา',
  da_null_offer_sequence: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_offer_rank: 'อันดับข้อเสนอที่บันทึก',
  da_source_offer_rank: 'หลักฐานในข้อเสนอที่บันทึกเท่านั้น หลักฐานที่ล้างแล้วยังคงว่าง แม้มีแหล่งอื่นเก็บอยู่',
  da_null_offer_rank: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_candidate_score: 'คะแนนผู้สมัครที่บันทึก',
  da_source_candidate_score: 'คะแนนที่บันทึกจากผลประเมินผู้สมัครที่เชื่อมตรงในโครงสร้างที่รองรับ ไม่คำนวณใหม่หรือแทนด้วยศูนย์',
  da_null_candidate_score: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_distance_to_pickup_km: 'ระยะทางถึงจุดรับที่บันทึก (กม.)',
  da_source_distance_to_pickup_km: 'หลักฐานในข้อเสนอที่บันทึกเท่านั้น หลักฐานที่ล้างแล้วยังคงว่าง แม้มีแหล่งอื่นเก็บอยู่',
  da_null_distance_to_pickup_km: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_offered_at: 'เวลาเสนอ',
  da_source_offered_at: 'ข้อมูลประวัติที่บันทึก เชื่อมการยืนยันด้วยรหัสข้อเสนอเท่านั้น ไม่จับคู่ด้วยเวลา',
  da_null_offered_at: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_expires_at: 'กำหนดหมดเวลาข้อเสนอ (ไม่ใช่เหตุการณ์หมดอายุ)',
  da_source_expires_at: 'กำหนดตอบที่บันทึก ไม่ใช่เวลาที่พิสูจน์การเปลี่ยนสถานะเป็นหมดอายุ',
  da_null_expires_at: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_responded_at: 'เวลาตอบข้อเสนอ',
  da_source_responded_at: 'ข้อมูลประวัติที่บันทึก เชื่อมการยืนยันด้วยรหัสข้อเสนอเท่านั้น ไม่จับคู่ด้วยเวลา',
  da_null_responded_at: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_confirmed_at: 'เวลายืนยัน',
  da_source_confirmed_at: 'ข้อมูลประวัติที่บันทึก เชื่อมการยืนยันด้วยรหัสข้อเสนอเท่านั้น ไม่จับคู่ด้วยเวลา',
  da_null_confirmed_at: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_reason_id: 'รหัสเหตุผล',
  da_source_reason_id: 'ข้อมูลประวัติที่บันทึก เชื่อมการยืนยันด้วยรหัสข้อเสนอเท่านั้น ไม่จับคู่ด้วยเวลา',
  da_null_reason_id: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_reason_code: 'รหัสเหตุผลที่บันทึก',
  da_source_reason_code: 'ข้อมูลประวัติที่บันทึก เชื่อมการยืนยันด้วยรหัสข้อเสนอเท่านั้น ไม่จับคู่ด้วยเวลา',
  da_null_reason_code: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_reason_label: 'ชื่อเหตุผลปัจจุบัน',
  da_source_reason_label: 'ชื่อเหตุผลปัจจุบันภายในหน่วยงาน ไม่ใช่ภาพชื่อ ณ เหตุการณ์',
  da_null_reason_label: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_reason_note: 'หมายเหตุเหตุผลที่บันทึก',
  da_source_reason_note: 'หลักฐานในข้อเสนอที่บันทึกเท่านั้น หลักฐานที่ล้างแล้วยังคงว่าง แม้มีแหล่งอื่นเก็บอยู่',
  da_null_reason_note: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_initiated_by_id: 'รหัสผู้เริ่มค้นหา',
  da_source_initiated_by_id:
    'ภาพประวัติและรหัสการค้นหาที่บันทึก ไม่ใช้รูปแบบจัดงานปัจจุบัน รูปแบบแถวแยกเดี่ยวใช้เฉพาะ mode/via ที่ระบุในเหตุการณ์',
  da_null_initiated_by_id: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_confirmation_actor_type: 'ประเภทผู้ยืนยัน',
  da_source_confirmation_actor_type:
    'ชื่อ รหัส และประเภทผู้ยืนยัน ณ เหตุการณ์จากเหตุการณ์ที่เชื่อมรหัสหรือประวัติตอบรับ รูปอ้างอิงโปรไฟล์ปัจจุบันเมื่อรองรับ',
  da_null_confirmation_actor_type:
    'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_confirmation_actor_id: 'รหัสผู้ยืนยัน',
  da_source_confirmation_actor_id:
    'ชื่อ รหัส และประเภทผู้ยืนยัน ณ เหตุการณ์จากเหตุการณ์ที่เชื่อมรหัสหรือประวัติตอบรับ รูปอ้างอิงโปรไฟล์ปัจจุบันเมื่อรองรับ',
  da_null_confirmation_actor_id: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_confirmation_actor_name: 'ชื่อผู้ยืนยัน ณ เหตุการณ์',
  da_source_confirmation_actor_name:
    'ชื่อ รหัส และประเภทผู้ยืนยัน ณ เหตุการณ์จากเหตุการณ์ที่เชื่อมรหัสหรือประวัติตอบรับ รูปอ้างอิงโปรไฟล์ปัจจุบันเมื่อรองรับ',
  da_null_confirmation_actor_name:
    'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_from_agent_id: 'รหัสพนักงานเดิม',
  da_source_from_agent_id: 'ข้อมูลประวัติที่บันทึก เชื่อมการยืนยันด้วยรหัสข้อเสนอเท่านั้น ไม่จับคู่ด้วยเวลา',
  da_null_from_agent_id: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_to_agent_id: 'รหัสพนักงานที่ยืนยัน',
  da_source_to_agent_id: 'ข้อมูลประวัติที่บันทึก เชื่อมการยืนยันด้วยรหัสข้อเสนอเท่านั้น ไม่จับคู่ด้วยเวลา',
  da_null_to_agent_id: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_confirmation_outcome: 'ผลการยืนยัน',
  da_source_confirmation_outcome: 'ข้อมูลประวัติที่บันทึก เชื่อมการยืนยันด้วยรหัสข้อเสนอเท่านั้น ไม่จับคู่ด้วยเวลา',
  da_null_confirmation_outcome: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_evidence_state: 'สถานะหลักฐาน',
  da_source_evidence_state:
    'ตัวบ่งชี้ล้างหลักฐานในข้อเสนอ ผลประเมิน หรือรอบประเมินมีลำดับก่อน เปิดเผยข้อมูลเดิม ข้อมูลขาด และโครงสร้างไม่รองรับ ไม่สร้างคะแนนย้อนหลัง',
  da_null_evidence_state: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_evidence_expired_at: 'เวลาล้างหลักฐาน',
  da_source_evidence_expired_at:
    'ตัวบ่งชี้ล้างหลักฐานในข้อเสนอ ผลประเมิน หรือรอบประเมินมีลำดับก่อน เปิดเผยข้อมูลเดิม ข้อมูลขาด และโครงสร้างไม่รองรับ ไม่สร้างคะแนนย้อนหลัง',
  da_null_evidence_expired_at: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
  da_col_scope_provenance: 'ที่มาขอบเขตพื้นที่บริการ',
  da_source_scope_provenance:
    'ข้อมูลประกอบงานปัจจุบัน วันบริการใช้เวลานัดหรือเวลาสร้าง ตัวกรองพื้นที่ใช้ผังกลุ่มบริการปัจจุบัน ไม่ใช้พื้นที่รอบประเมิน',
  da_null_scope_provenance: 'ไม่มีการบันทึก ไม่เกี่ยวข้อง ไม่รองรับ คลุมเครือ หรือถูกล้างตามระยะเก็บ ไม่แทนด้วยค่าที่สร้างขึ้น',
};
export const driverAssignmentDetailTranslations = { th, en };
